/*
***This is for the slideshow on the home page
*/

$(document).ready(function(){


  //This section is for the store alt 3 top slideshow
  var pressImagesX = $("#store-slider-inner img");
  //set press-slider-inner to the size of the images it contains
  $("#store-slider-inner").css("width", (pressImagesX.length*125))


  var images = $("#slideshow-images img");
  var imgLength = images.length;

  var num = 1;

  function fadeIt(){


    if (num == 1){
      $("#slideshow-container img:nth-child(" + (imgLength) + ")").removeClass("current-slide").addClass("previous-slide"); 
      $("#slideshow-container img:nth-child(" + (imgLength-1) + ")").removeClass("previous-slide");       

    }
    else if(num == 2){
      $("#slideshow-container img:nth-child(" + (num-1) + ")").removeClass("current-slide").addClass("previous-slide"); 
      $("#slideshow-container img:nth-child(" + (imgLength) + ")").removeClass("previous-slide"); 
    }
    else{ 
      $("#slideshow-container img:nth-child(" + (num-1) + ")").removeClass("current-slide").addClass("previous-slide"); 
      $("#slideshow-container img:nth-child(" + (num-2) + ")").removeClass("previous-slide"); 

    }

    $("#slideshow-images img:nth-child(" + num + ")").css({ opacity: 0.0 }).addClass("current-slide").animate({ opacity: 1.0 }, 800 /* ,
        function() {
     //$("#slideshow-container img:nth-child(" + (num-1) + ")").css({ opacity: 0.0 });
          }*/);

    // console.log(num);
    if (num < (imgLength)){num++} 
    else {num = 1}

    //call self again in 2.5 seconds
    setTimeout(fadeIt,2500);
  }



  fadeIt();

  /*This is for the footer press slider
  **
  **so have a css transform that moves the slider one image over, then immediately after 
  **(maybe on a timed delay equal to the time it takes to move the img?), add the next image to
  **the end, get rid of the image that just disappeared, and recall the function
  */

  var pressImages = $("#press-slider-inner img")

  //set press-slider-inner to the size of the images it contains
  $("#press-slider-inner").css("width", (pressImages.length*125))

}); //end document.ready

window.onload = function(){

  var pressImages = $("#press-slider img")
  var num = 0;  
  var translation = -125;



  function pressSlide()   { 

    //var pressImagesLength = $("#press-slider-inner img").length*125

    $("#press-slider-inner").css("transform", "translate("+translation+"px)")
    $("#press-slider-inner").css("transition", "3s linear")

    translation = translation - 125;

    var slide = document.getElementsByClassName("press-slider-img")[num].innerHTML
    var lastSlide = "<div class = 'press-slider-img'>" + slide + "</div>"
    document.getElementById("press-slider-inner").innerHTML = document.getElementById("press-slider-inner").innerHTML + lastSlide;

    var pressImagesLength = $("#press-slider-inner img").length*125
    $("#press-slider-inner").css("width", pressImagesLength) 

    /*
    $("#press-slider-inner div:nth-child(" + num + ")").css("display", "none");
   	$("#press-slider-inner").css("transform", "translate(0px)")
    $("#press-slider-inner").css("transition", "0s")
    */
    num++


    setTimeout(function(){
      /*$("#press-slider-inner div:nth-child(" + num + ")").css("display", "none");
   	$("#press-slider-inner").css("transform", "translate(0px)")
    $("#press-slider-inner").css("transition", "0s")
     num++*/
      pressSlide()
    }, 3000);


  } //end pressSlide

  pressSlide()

















  var pressImagesX = $("#store-alt-slider img")
  var numX = 0; 
  var pressTimerX = $("#store-slider-inner img").length*3-21
  var timeOutX = pressTimerX*1000
  var pressImagesLengthX = $("#store-slider-inner img").length*125
  var pressImagesTransX = $("#store-slider-inner img").length*125-940
  var translationX = pressImagesTransX*-1;

  function pressSlide2()   { 
    $("#store-slider-inner").css("width", pressImagesLengthX) 

    $("#store-slider-inner").css("transform", "translate("+translationX+"px)")
    $("#store-slider-inner").css("transition", ""+pressTimerX+"s linear")




    setTimeout(function(){

      toSlide2()
    }, timeOutX);


  } //end pressSlide


  function toSlide2(){
    $("#store-slider-inner").css("transform", "translate(0px)")
    $("#store-slider-inner").css("transition", "0s linear")

    setTimeout(function(){


      pressSlide2()
    }, 10);

  }





  pressSlide2()




} //end window.onload














